// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"ee1e292a","247":"7f9d64db","513":"5aa9774b","665":"f35357ee","706":"cc727622"}[chunkId] + ".chunk.js";
};